import { render, staticRenderFns } from "./UserFactoryRelationsList.vue?vue&type=template&id=0678e6ba&scoped=true&"
import script from "./UserFactoryRelationsList.vue?vue&type=script&lang=ts&"
export * from "./UserFactoryRelationsList.vue?vue&type=script&lang=ts&"
import style0 from "./UserFactoryRelationsList.vue?vue&type=style&index=0&id=0678e6ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678e6ba",
  null
  
)

export default component.exports